import { useEffect, type PropsWithChildren } from 'react';
import EligibilityWidgetTokenStatus from './EligibilityWidgetTokenStatus';
import useTranslation from '../../states/translation/useTranslation';
import type { WidgetOfferLink } from '../../../types/eligibilityWidget/EligibilityWidgetToken';

interface EligibilityWidgetTokenEligibleProps extends PropsWithChildren {
  links: WidgetOfferLink[];
  openLinks: (links: WidgetOfferLink[]) => void;
}

const EligibilityWidgetTokenEligible: React.FC<EligibilityWidgetTokenEligibleProps> = ({
  links,
  openLinks,
  ...props
}) => {
  const { t } = useTranslation().actions;

  useEffect(() => {
    openLinks(links);
  }, [links]);

  return (
    <EligibilityWidgetTokenStatus
      header={t('eligibility-widget.card.header.eligible')}
      body={t('eligibility-widget.card.body.eligible')}
      {...props}
    />
  );
};

export default EligibilityWidgetTokenEligible;
